/* ==========================================================
   QUICKSHOTS — quickshots.js
   Dawn 15.5.0 · No dependencies · Deferred
   ========================================================== */
'use strict';

/* ── SHOT COLOUR PALETTE ── */
const QS = {
  COLS: ['#C9A01A','#E87020','#CC2266','#9030C0','#8BC830','#CC3300','#F0C400','#4C8A22'],

  /* ── PIXEL SCATTER ── */
  scatter(id, count, subtle = false) {
    const el = document.getElementById(id);
    if (!el) return;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < count; i++) {
      const s = document.createElement('span');
      s.className = 'qs-pxl';
      const sz = subtle ? 4 + Math.random() * 8 : 4 + Math.random() * 10;
      const op = subtle ? 0.18 + Math.random() * 0.20 : 0.28 + Math.random() * 0.36;
      Object.assign(s.style, {
        width: sz + 'px', height: sz + 'px',
        top: Math.random() * 100 + '%',
        left: Math.random() * 100 + '%',
        background: QS.COLS[Math.floor(Math.random() * QS.COLS.length)],
        animationDuration: (3.2 + Math.random() * 3.4) + 's',
        animationDelay: (Math.random() * 5) + 's',
        animationFillMode: 'both',
      });
      s.style.setProperty('--qs-op', op);
      frag.appendChild(s);
    }
    el.appendChild(frag);
  },

  pixelRule(id) {
    const el = document.getElementById(id);
    if (!el) return;
    const frag = document.createDocumentFragment();
    for (let i = 0; i < 90; i++) {
      const s = document.createElement('span');
      s.style.background = Math.random() < .44
        ? QS.COLS[Math.floor(Math.random() * QS.COLS.length)]
        : 'transparent';
      frag.appendChild(s);
    }
    el.appendChild(frag);
  },

  /* ── CHECK-PILL RAYS ── */
  buildRays(pill, idx) {
    const W = pill.offsetWidth;
    const H = pill.offsetHeight;
    const positions = [
      [12, 0, -14, -28], [W * .35, 0, -4, -32], [W * .65, 0, 4, -32], [W - 12, 0, 14, -28],
      [W, H * .5, 30, 0], [W - 12, H, 14, 28], [W * .6, H, 4, 32], [W * .4, H, -4, 32],
      [12, H, -14, 28], [0, H * .5, -30, 0],
      [W * .18, 0, -10, -30], [W * .82, 0, 10, -30],
    ];
    const frag = document.createDocumentFragment();
    positions.forEach(([cx, cy, tx, ty], ri) => {
      const size = 8 + (ri % 4 === 0 ? 4 : ri % 3 === 0 ? 2 : 0);
      const col  = QS.COLS[(idx * 4 + ri) % QS.COLS.length];
      const dur  = 1.8 + (ri % 5) * 0.22;
      const del  = ((idx * 0.07 + ri * 0.2) % dur).toFixed(2);
      const r = document.createElement('div');
      r.className = 'qs-ray';
      Object.assign(r.style, {
        width: size + 'px', height: size + 'px', background: col,
        left: (cx - size / 2) + 'px', top: (cy - size / 2) + 'px',
        animationDuration: dur + 's', animationDelay: '-' + del + 's',
      });
      r.style.setProperty('--tx', tx + 'px');
      r.style.setProperty('--ty', ty + 'px');
      frag.appendChild(r);
    });
    pill.appendChild(frag);
  },

  initPills() {
    document.querySelectorAll('.qs-check-pill').forEach((pill, i) => {
      QS.buildRays(pill, i);
    });
  },

  /* ── SCROLL REVEAL ── */
  initReveal() {
    if (!('IntersectionObserver' in window)) {
      document.querySelectorAll('.qs-reveal').forEach(el => el.classList.add('qs-in'));
      return;
    }
    const obs = new IntersectionObserver(entries => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.classList.add('qs-in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    document.querySelectorAll('.qs-reveal').forEach(el => obs.observe(el));
  },

  /* ── FAQ ACCORDION ── */
  initFAQ() {
    document.querySelectorAll('.qs-faq-item').forEach(item => {
      const btn = item.querySelector('.qs-faq-q');
      const ans = item.querySelector('.qs-faq-a');
      if (!btn || !ans) return;
      btn.addEventListener('click', () => {
        const open = item.getAttribute('aria-expanded') === 'true';
        document.querySelectorAll('.qs-faq-item[aria-expanded="true"]').forEach(o => {
          o.setAttribute('aria-expanded', 'false');
          const a = o.querySelector('.qs-faq-a');
          if (a) a.style.maxHeight = null;
        });
        if (!open) {
          item.setAttribute('aria-expanded', 'true');
          ans.style.maxHeight = ans.scrollHeight + 'px';
        }
      });
    });
  },

  /* ── CONTENT TABS ── */
  initTabs() {
    document.querySelectorAll('.qs-tab-btn').forEach(btn => {
      btn.addEventListener('click', () => {
        const container = btn.closest('[data-qs-tabs]') || document;
        container.querySelectorAll('.qs-tab-btn, .qs-tab-panel').forEach(el => el.classList.remove('qs-active'));
        btn.classList.add('qs-active');
        const panel = container.querySelector('#qs-tab-' + btn.dataset.tab);
        if (panel) panel.classList.add('qs-active');
      });
    });
  },

  /* ── MOBILE NAV ── */
  initMobileNav() {
    const btn = document.getElementById('qs-burger');
    const nav = document.getElementById('qs-mobile-nav');
    if (!btn || !nav) return;
    btn.addEventListener('click', () => {
      const expanded = nav.getAttribute('aria-expanded') === 'true';
      nav.setAttribute('aria-expanded', String(!expanded));
      btn.setAttribute('aria-expanded', String(!expanded));
      const iconOpen  = btn.querySelector('.qs-burger-open');
      const iconClose = btn.querySelector('.qs-burger-close');
      if (iconOpen)  iconOpen.style.display  = expanded ? 'block' : 'none';
      if (iconClose) iconClose.style.display = expanded ? 'none'  : 'block';
    });
  },

  /* ── TOAST ── */
  _toastTimer: null,
  showToast(msg) {
    const toast = document.getElementById('qs-toast');
    const text  = document.getElementById('qs-toast-text');
    if (!toast || !text) return;
    text.textContent = msg;
    toast.classList.add('qs-show');
    clearTimeout(QS._toastTimer);
    QS._toastTimer = setTimeout(() => toast.classList.remove('qs-show'), 2600);
  },

  /* ── PRICING / ABO TOGGLE (homepage) ── */
  initPricingToggle() {
    const toggle = document.getElementById('qs-price-toggle');
    if (!toggle) return;
    const knob    = document.getElementById('qs-toggle-knob');
    const badge   = document.getElementById('qs-save-badge');
    const btns    = toggle.querySelectorAll('button');

    // Set knob width
    if (knob && btns.length) knob.style.width = `calc(${100 / btns.length}% - 4px)`;

    toggle.addEventListener('click', e => {
      const btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      const isAbo = btn.dataset.mode === 'abo';
      btns.forEach(b => b.classList.remove('qs-active'));
      btn.classList.add('qs-active');
      toggle.classList.toggle('qs-is-abo', isAbo);
      if (badge) badge.classList.toggle('qs-visible', isAbo);

      document.querySelectorAll('.qs-abo-el').forEach(el => {
        if (!isAbo) { el.style.display = 'none'; return; }
        const cl = el.classList;
        if (cl.contains('qs-savings-pill'))  el.style.display = 'flex';
        else if (cl.contains('qs-delivery-tag'))  el.style.display = 'flex';
        else if (cl.contains('qs-flavour-info'))  el.style.display = 'flex';
        else if (cl.contains('qs-first-order'))   el.style.display = 'flex';
        else if (cl.contains('qs-gift-bonus'))    el.style.display = 'flex';
        else if (cl.contains('qs-fo-footnote'))   el.style.display = 'block';
        else if (cl.contains('qs-abo-details'))   el.style.display = 'flex';
        else if (el.tagName === 'LI')             el.style.display = 'flex';
        else el.style.display = 'flex';
      });

      // Price swap
      const p50  = document.getElementById('qs-price-50');
      const p100 = document.getElementById('qs-price-100');
      const pd50  = document.getElementById('qs-perday-50');
      const pd100 = document.getElementById('qs-perday-100');
      const sp50  = document.getElementById('qs-sp-50');
      const sp100 = document.getElementById('qs-sp-100');
      if (isAbo) {
        if (p50)   p50.innerHTML  = '14,90&nbsp;€ <span class="qs-old">19,90&nbsp;€</span>';
        if (p100)  p100.innerHTML = '24,90&nbsp;€ <span class="qs-old">29,90&nbsp;€</span>';
        if (pd50)  pd50.textContent = '0,60 € pro Tag · 25 Tage';
        if (pd100) pd100.textContent = '0,50 € pro Tag · 50 Tage';
        if (sp50)  sp50.textContent  = '14,90 €';
        if (sp100) sp100.textContent = '24,90 €';
      } else {
        if (p50)   p50.textContent  = '19,90 €';
        if (p100)  p100.textContent = '29,90 €';
        if (pd50)  pd50.textContent = '0,80 € pro Tag · 25 Tage';
        if (pd100) pd100.textContent = '0,60 € pro Tag · 50 Tage';
        if (sp50)  sp50.textContent  = '19,90 €';
        if (sp100) sp100.textContent = '29,90 €';
      }
    });
  },

  /* ── BUNDLE FLAVOR PICKERS ── */
  initBundlePickers() {
    const FLAVORS = ['Ingwer','Ingwer-Berry','Ingwer-Zimt','Acai Beere','Spice Booster','Green Matcha'];

    function makePills(wrap, single) {
      if (!wrap) return;
      FLAVORS.forEach((f, fi) => {
        const btn = document.createElement('button');
        btn.className = 'qs-bp-pill' + (fi === 0 ? ' qs-active' : '');
        btn.textContent = f;
        btn.type = 'button';
        btn.onclick = () => {
          if (single) wrap.querySelectorAll('.qs-bp-pill').forEach(b => b.classList.remove('qs-active'));
          btn.classList.add('qs-active');
        };
        wrap.appendChild(btn);
      });
    }

    makePills(document.getElementById('qs-starter-pills'), true);

    const trioPickers = document.getElementById('qs-trio-pickers');
    if (trioPickers) {
      [0, 1, 2].forEach(idx => {
        const slot = document.createElement('div');
        slot.innerHTML = `<div class="qs-bp-slot-lbl"><span class="qs-bp-n">${idx + 1}</span>Shot ${idx + 1} — Sorte wählen</div><div class="qs-bp-pills" id="qs-trio-${idx}"></div>`;
        trioPickers.appendChild(slot);
        FLAVORS.forEach((f, fi) => {
          const btn = document.createElement('button');
          btn.className = 'qs-bp-pill' + (fi === idx ? ' qs-active' : '');
          btn.textContent = f;
          btn.type = 'button';
          const pills = slot.querySelector('.qs-bp-pills');
          btn.onclick = () => {
            pills.querySelectorAll('.qs-bp-pill').forEach(b => b.classList.remove('qs-active'));
            btn.classList.add('qs-active');
          };
          slot.querySelector('.qs-bp-pills').appendChild(btn);
        });
      });
    }
  },

  addBundle(type) {
    const FLAVORS = ['Ingwer','Ingwer-Berry','Ingwer-Zimt','Acai Beere','Spice Booster','Green Matcha'];
    let label = '';
    if (type === 'starter') {
      const a = document.querySelector('#qs-starter-pills .qs-bp-pill.qs-active');
      label = `Starterset (${a ? a.textContent : 'Ingwer'} 100g + Glas + Löffel)`;
    } else {
      const slots = [0,1,2].map(i => {
        const a = document.querySelector(`#qs-trio-${i} .qs-bp-pill.qs-active`);
        return a ? a.textContent : FLAVORS[i];
      });
      label = `Probiertrio (${slots.join(', ')})`;
    }
    // Update Shopify cart counter
    const counter = document.querySelector('.qs-cart-count, [id^="CartCount"]');
    if (counter) {
      const n = parseInt(counter.textContent || '0', 10);
      counter.textContent = n + 1;
    }
    QS.showToast(label + ' zum Warenkorb hinzugefügt');
  },

  /* ── PRODUCT PAGE: SELLING PLANS + VARIANT ── */
  initProductPage() {
    const form        = document.querySelector('form[id^="product-form"]');
    const purchToggle = document.getElementById('qs-purch-toggle');
    const purchKnob   = document.getElementById('qs-purch-knob');
    const spInput     = document.getElementById('qs-selling-plan');
    if (!purchToggle) return;

    const btns = purchToggle.querySelectorAll('button[data-mode]');
    if (purchKnob && btns.length) purchKnob.style.width = `calc(${100 / btns.length}% - 4px)`;

    purchToggle.addEventListener('click', e => {
      const btn = e.target.closest('button[data-mode]');
      if (!btn) return;
      const isAbo = btn.dataset.mode === 'abo';
      btns.forEach(b => b.classList.remove('qs-active'));
      btn.classList.add('qs-active');
      purchToggle.classList.toggle('qs-is-abo', isAbo);

      // Show/hide abo elements
      document.querySelectorAll('.qs-abo-el').forEach(el => {
        if (!isAbo) { el.style.display = 'none'; return; }
        const cl = el.classList;
        if (cl.contains('qs-savings-pill'))  el.style.display = 'flex';
        else if (cl.contains('qs-first-order'))   el.style.display = 'flex';
        else if (cl.contains('qs-gift-bonus'))    el.style.display = 'flex';
        else if (cl.contains('qs-fo-footnote'))   el.style.display = 'block';
        else if (cl.contains('qs-abo-details'))   el.style.display = 'flex';
        else el.style.display = 'flex';
      });

      // Set selling plan for the currently selected variant
      if (spInput) {
        if (isAbo) {
          QS.setSellingPlanForCurrentVariant(spInput);
        } else {
          spInput.value = '';
        }
      }

      // Update price display
      QS.updateProductPrice(isAbo);
    });

    // Size pill selection
    document.querySelectorAll('.qs-size-pill').forEach(pill => {
      pill.addEventListener('click', () => {
        document.querySelectorAll('.qs-size-pill').forEach(p => p.classList.remove('qs-active'));
        pill.classList.add('qs-active');
        const varInput = document.querySelector('input[name="id"]');
        if (varInput && pill.dataset.variantId) varInput.value = pill.dataset.variantId;
        const lbl = document.getElementById('qs-size-lbl');
        if (lbl) lbl.textContent = pill.dataset.label || pill.querySelector('.qs-sp-size')?.textContent;
        const isAbo = purchToggle.classList.contains('qs-is-abo');
        // Update selling plan to match the newly selected variant
        if (isAbo && spInput) QS.setSellingPlanForCurrentVariant(spInput);
        QS.updateProductPrice(isAbo);
      });
    });
  },

  setSellingPlanForCurrentVariant(spInput) {
    const data = window.QS_PRODUCT_DATA;
    const vid  = document.querySelector('input[name="id"]')?.value;
    if (data && vid && data.variants[vid]) {
      const allocs = data.variants[vid].sellingPlanAllocations;
      if (allocs.length > 0) { spInput.value = String(allocs[0].sellingPlanId); return; }
    }
    // Fallback: first option from native select
    const sel = document.querySelector('select[name="selling_plan"]');
    spInput.value = (sel && sel.options[1]) ? sel.options[1].value : '';
  },

  updateProductPrice(isAbo) {
    const data = window.QS_PRODUCT_DATA;
    if (!data) return;
    const variantId = document.querySelector('input[name="id"]')?.value;
    if (!variantId) return;
    const vd = data.variants[variantId];
    if (!vd) return;

    // Pick price source
    let price, compareAtPrice;
    if (isAbo && vd.sellingPlanAllocations.length > 0) {
      const nativeSel = document.querySelector('select[name="selling_plan"]');
      const spId = nativeSel && nativeSel.options[1] ? parseInt(nativeSel.options[1].value, 10) : null;
      const spa = (spId ? vd.sellingPlanAllocations.find(a => a.sellingPlanId === spId) : null)
                  || vd.sellingPlanAllocations[0];
      price = spa.price;
      compareAtPrice = vd.price; // one-time price as crossed-out
    } else {
      price = vd.price;
      compareAtPrice = vd.compareAtPrice;
    }

    // Money formatter: cents → "XX,XX €"
    const fmt = c => (c / 100).toLocaleString('de-AT', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

    // Main price
    const priceEl = document.getElementById('qs-price-now');
    const oldEl   = document.getElementById('qs-price-old');
    if (priceEl) priceEl.textContent = fmt(price);
    if (oldEl) {
      if (compareAtPrice && compareAtPrice > price) {
        oldEl.textContent  = fmt(compareAtPrice);
        oldEl.style.display = 'inline';
      } else {
        oldEl.textContent  = '';
        oldEl.style.display = 'none';
      }
    }

    // Per-day price
    const perDayEl = document.getElementById('qs-price-perday');
    if (perDayEl) {
      const t = vd.title.toLowerCase();
      if (t.includes('100'))      perDayEl.textContent = (price / 5000).toFixed(2).replace('.', ',') + ' € pro Tag · 50 Tage';
      else if (t.includes('50')) perDayEl.textContent = (price / 2500).toFixed(2).replace('.', ',') + ' € pro Tag · 25 Tage';
      else                        perDayEl.textContent = '';
    }

    // Savings pill
    const savTxt = document.getElementById('qs-savings-text');
    if (savTxt) {
      if (isAbo && compareAtPrice > price) {
        const pct = Math.round((1 - price / compareAtPrice) * 100);
        savTxt.textContent = pct + ' % gespart';
      }
    }

    // First order text — fixed discount: 15 € for 100g, 10 € for 50g
    const foText = document.getElementById('qs-fo-text');
    if (foText && isAbo) {
      const foDisc = vd.title.toLowerCase().includes('100') ? 1500 : 1000;
      foText.innerHTML = `Einmalig <b>−${fmt(foDisc)}</b> bei deiner ersten Bestellung. Ab der 2. Lieferung ${fmt(price)}.`;
    }

    // Delivery text
    const delTxt = document.getElementById('qs-delivery-text');
    if (delTxt) {
      const days = vd.title.toLowerCase().includes('100') ? '50' : '25';
      delTxt.textContent = `Automatische Lieferung alle ${days} Tage`;
    }

    // Update price shown inside each size pill
    document.querySelectorAll('.qs-size-pill').forEach(pill => {
      const pid = pill.dataset.variantId;
      if (!pid || !data.variants[pid]) return;
      const pvd = data.variants[pid];
      const pp = (isAbo && pvd.sellingPlanAllocations[0])
                 ? pvd.sellingPlanAllocations[0].price
                 : pvd.price;
      const span = pill.querySelector('.qs-sp-price');
      if (span) span.textContent = fmt(pp);
    });
  },

  /* ── AJAX ADD TO CART ── */
  async addToCart(variantId, qty, sellingPlan) {
    const body = { id: parseInt(variantId, 10), quantity: qty || 1 };
    if (sellingPlan) body.selling_plan = parseInt(sellingPlan, 10);
    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body),
      });
      if (!res.ok) throw new Error('Cart error');
      const cartRes = await fetch('/cart.js');
      const cart    = await cartRes.json();
      // Update all cart count elements
      document.querySelectorAll('.qs-cart-count, [aria-label*="Warenkorb"]').forEach(el => {
        if (el.tagName !== 'A') el.textContent = cart.item_count;
      });
      if (typeof fbq !== 'undefined') fbq('track', 'AddToCart');
      return cart;
    } catch (err) {
      console.error('QS cart error:', err);
    }
  },

  /* ── PRODUCT FORM INTERCEPT ── */
  initProductForm() {
    const form = document.getElementById('qs-product-form');
    if (!form) return;
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = form.querySelector('.qs-add-btn');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      const variantId    = form.querySelector('[name="id"]')?.value;
      const sellingPlan  = document.getElementById('qs-selling-plan')?.value || '';
      try {
        await QS.addToCart(variantId, 1, sellingPlan);
        QS.showToast('Zum Warenkorb hinzugefügt');
      } catch {
        QS.showToast('Fehler – bitte nochmals versuchen');
      } finally {
        if (btn) {
          btn.disabled = false;
          btn.innerHTML = `<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 9h14l-1.5 10a2 2 0 01-2 1.8H8.5a2 2 0 01-2-1.8L5 9z"/><path d="M9 9V6a3 3 0 016 0v3"/></svg>In den Warenkorb`;
        }
      }
    });
  },

  /* ── BLOG CATEGORY FILTER ── */
  initBlogFilter() {
    const strip = document.getElementById('qs-cat-strip');
    const grid  = document.getElementById('qs-article-grid');
    if (!strip || !grid) return;
    strip.addEventListener('click', e => {
      const pill = e.target.closest('.qs-cat-pill');
      if (!pill) return;
      strip.querySelectorAll('.qs-cat-pill').forEach(p => p.classList.remove('qs-active'));
      pill.classList.add('qs-active');
      const cat = pill.dataset.cat;
      grid.querySelectorAll('.qs-article-card').forEach(card => {
        card.style.display = (cat === 'alle' || card.dataset.cat === cat) ? '' : 'none';
      });
    });
  },

  /* ── INIT ALL ── */
  init() {
    // Pixels — defer until IntersectionObserver fires
    if ('IntersectionObserver' in window) {
      const pixObs = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (!e.isIntersecting) return;
          const id = e.target.dataset.qsPixels;
          const count = parseInt(e.target.dataset.qsCount || '20', 10);
          const subtle = e.target.dataset.qsSubtle === 'true';
          QS.scatter(id, count, subtle);
          pixObs.unobserve(e.target);
        });
      }, { rootMargin: '200px' });
      document.querySelectorAll('[data-qs-pixels]').forEach(el => pixObs.observe(el));
    }

    QS.pixelRule('qs-pixel-rule-1');
    QS.pixelRule('qs-pixel-rule-2');

    // Check pills — only after section is visible
    if ('IntersectionObserver' in window) {
      const pillsSection = document.querySelector('.qs-pill-strip');
      if (pillsSection) {
        const pillObs = new IntersectionObserver(entries => {
          entries.forEach(e => {
            if (e.isIntersecting) { QS.initPills(); pillObs.disconnect(); }
          });
        }, { threshold: 0.1 });
        pillObs.observe(pillsSection);
      }
    } else {
      QS.initPills();
    }

    QS.initReveal();
    QS.initFAQ();
    QS.initTabs();
    QS.initMobileNav();
    QS.initPricingToggle();
    QS.initBundlePickers();
    QS.initProductPage();
    QS.initProductForm();
    QS.initBlogFilter();
  },
};

window.QS = QS;
window.QS_addBundle = (type) => QS.addBundle(type);

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => QS.init());
} else {
  QS.init();
}
